import cn from './currencies-position.module.css';

const CurrenciesPositionHeader = () => (
  <div className={cn.currenciesPositionHeader}>
    <div className={cn.currenciesHeaderValue} />
    <div className={cn.currenciesHeaderValue}>Short (Buy)</div>
    <div className={cn.currenciesHeaderValue}>Long (Sell)</div>
  </div>
);

export default CurrenciesPositionHeader;
